module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Order Info","pleaseEnterPhoneNumber":"Please enter phone number"},"zh-tw":{"title":"訂單資訊","pleaseEnterPhoneNumber":"請輸入手機號碼"}}')
  delete Component.options._Ctor
}
